var map = {
	"./blogr.svg": 6016,
	"./coffeeroasters.svg": 5662,
	"./creative.svg": 2047,
	"./crowdfund.svg": 4770,
	"./maker.svg": 8798,
	"./mastercraft.svg": 5236,
	"./officelite.svg": 8832,
	"./pod.svg": 4655,
	"./pomodoro.svg": 4567,
	"./scoot.svg": 4893,
	"./typemaster.svg": 3477,
	"./vector.svg": 1730
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7791;